export interface cycleProductDataType {
    activityCycleProductId: number,
    userActivityId: number,
    activityId: number,
    activityCycleId: number,
    userActivityCycleId: number,
    productId: number,
    productName: string,
    costPrice: number,
    productGrade: string,
    stock: number,
    selectNum: number,
    accountType:string
}

export const column = [
    {
        title: '权益名称',
        dataIndex: 'productName',
        key: 'productName',
        width:300
    },
    {
        title: '库存',
        dataIndex: 'stock',
        key: 'stock', 
    },
    {
        title: '成本价',
        dataIndex:'costPrice',
        key:'costPrice',  
    },
    {
        title: '权益档次',
        dataIndex:'productGrade',
        key:'productGrade',
        width: 100,
    }
]